<template>
  <div class="ServiceAdvantage">
    <div class="cont">
      <ComTitlte
        class="c_title"
        titleEn="SERVICE ADVANTAGE"
        titleZh="服务优势"
      ></ComTitlte>
      <div class="main">
        <div class="advantageList">
          <div class="a_item">
            <i class="a_icon a_icon1"></i>
            <div class="a_info">
              <div class="i_title">研究及专家队伍</div>
              <div class="i_desc p_style">
                拥有一批经济学、社会学、统计学、人类学、计算机、应用数学、市场营销学、工商管理学等相关学科方面的优秀人才，并有一批来自中山大学、华南理工大学、暨南大学、广东财经大学等重点高校、广州市社科院等多个科研院所的学者所组成的专家顾问队伍。
              </div>
            </div>
          </div>
          <div class="a_item">
            <i class="a_icon a_icon2"></i>
            <div class="a_info">
              <div class="i_title">调查队伍及项目经验</div>
              <div class="i_desc p_style">
                拥有200多名稳定的、经过长期严格培训且具有丰富调查实地执行经验的调查员队伍和督导员队伍，参与完成2017年广州市全市交通出行调查、广州市天河区第四次全国经济普查等大型调查项目。
              </div>
            </div>
          </div>
        </div>
        <div class="advantage_desc p_style">
          20多年来，我所一直是广州市城市万户居民调查的重要参与者、承担者，亦承接着广州市农村千户调查的网络组建与维护、调查设计和实施、研究分析等工作。我所以丰富的从业经验、完备的调查网络、全面的信息资源、广泛的社会关系和朝气蓬勃的队伍，与客户长期保持良好合作沟通，为客户提供优质服务。截至目前，我所已采集研究所需调查问卷近千万份，完成数千个高质量项目。
        </div>
        <div class="box_a">
          <div class="b_dataList">
            <div class="b_dataItem">
              <div class="data_icon data_icon1"></div>
              <div class="data_lable">专业团队</div>
              <div class="data_value">
                <span class="v_num">200</span>
                <span class="v_unit">名</span>
              </div>
            </div>

            <div class="b_dataItem">
              <div class="data_icon data_icon3"></div>
              <div class="data_lable">从业经验</div>
              <div class="data_value">
                <span class="v_num">20</span>
                <span class="v_unit">年</span>
              </div>
            </div>
            <div class="b_dataItem">
              <div class="data_icon data_icon4"></div>
              <div class="data_lable">完成调查问卷</div>
              <div class="data_value">
                <span class="v_num">1000W+</span>
                <span class="v_unit"></span>
              </div>
            </div>
            <div class="b_dataItem">
              <div class="data_icon data_icon2"></div>
              <div class="data_lable">完成高质量项目</div>
              <div class="data_value">
                <span class="v_num">1000+</span>
                <span class="v_unit"></span>
              </div>
            </div>
          </div>
          <div class="b_imgList">
            <img src="../../assets/img/company/b_img1.png" alt="..." />
            <img src="../../assets/img/company/b_img2.png" alt="..." />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ComTitlte from "@/components/common/comTitle";
export default {
  name: "ServiceAdvantage",
  components: { ComTitlte },
};
</script>

<style lang="scss" scoped>
$themeColor: #406cdd;
$themeMinWidth: 1180px;
.ServiceAdvantage {
  background-color: #f5f6f9;
  position: relative;
  padding: 0 0 20px 0;
  &::after {
    display: block;
    content: "";
    width: 100%;
    height: 250px;
    background-color: #ffffff;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
  }
}
.p_style {
  font-size: 16px;
  text-indent: 32px;
  line-height: 30px;
  text-align: justify;
  color: #666666;
}
.cont {
  width: $themeMinWidth;
  margin: 0 auto;
  position: relative;
  z-index: 6;
  .main {
    padding: 40px 0 0 0;
    .advantageList {
      display: flex;
      justify-content: space-between;
      .a_item {
        display: flex;
        width: 564px;
        height: 215px;
        background-color: #ffffff;
        box-shadow: 2px 3px 21px 0px rgba(22, 22, 22, 0.05);
        box-sizing: border-box;
        padding: 15px 20px 15px 15px;
        .a_icon {
          flex-shrink: 0;
          display: inline-block;
          width: 58px;
          height: 58px;
          margin: 0 10px 0 0;
          &.a_icon1 {
            background: url("../../assets/img/company/b_icon1.png") no-repeat;
            background-size: cover;
          }
          &.a_icon2 {
            background: url("../../assets/img/company/b_icon2.png") no-repeat;
            background-size: cover;
          }
        }
        .a_info {
          .i_title {
            font-size: 20px;
            color: #333333;
            padding: 10px 0 0 0;
          }
          .i_desc {
            text-indent: 0;
            font-size: 16px;
            line-height: 24px;
            padding: 20px 0 0 0;
          }
        }
      }
    }
    .advantage_desc {
      padding: 50px 0 0 0;
    }
    .box_a {
      display: flex;
      justify-content: space-between;
      height: 188px;
      .b_dataList {
        display: flex;
        justify-content: space-between;
        width: 566px;
        .b_dataItem {
          padding: 44px 0 0 0;
          .data_icon {
            width: 42px;
            height: 42px;
            margin: 0 auto 20px;
            &.data_icon1 {
              background: url("../../assets/img/company/b_icon3.png") no-repeat;
              background-size: cover;
            }
            &.data_icon2 {
              background: url("../../assets/img/company/b_icon4.png") no-repeat;
              background-size: cover;
            }
            &.data_icon3 {
              background: url("../../assets/img/company/b_icon5.png") no-repeat;
              background-size: cover;
            }
            &.data_icon4 {
              background: url("../../assets/img/company/b_icon6.png") no-repeat;
              background-size: cover;
            }
          }
          .data_lable {
            font-size: 18px;
            color: #666666;
            padding: 0 0 10px 0;
          }
          .data_value {
            width: 100%;
            text-align: center;
            .v_num {
              font-weight: bold;
              font-size: 24px;
              color: #406cdd;
            }
            .v_unit {
              font-weight: bold;
              font-size: 18px;
              color: #406cdd;
              text-align: center;
            }
          }
        }
      }
      .b_imgList {
        display: flex;
        justify-content: space-between;
        width: 576px;
        img {
          display: block;
          width: 270px;
          height: 186px;
          object-fit: cover;
        }
      }
    }
  }
}
</style>
